import React, { useState, useEffect } from "react"
import { Link, useParams, useNavigate } from "react-router-dom"
import axios from "axios"
import { FaBars } from 'react-icons/fa'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Button from 'react-bootstrap/Button'
import { apiURL, filesURL, sitePath } from 'config/globals'
import DataTable from 'components/DataTable'
import Sidebar from 'components/Sidebar'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const TableDetails = (props) => {
    const [currentUser, setCurrentUser] = useState(false)
    const [tableData, setTableData] = useState([])
    const { tableName } = useParams()
    const navigate = useNavigate()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            getData()
        }
        start()
    }, [tableName])

    const getData = async () => {
        const response = await axios.get(`${apiURL}/get-table-data/${tableName}`)
        if (response.data.rows) {
            response.data.rows = response.data.rows.reverse()
        }
        setTableData(response.data)
    }

    const beautify = (data) => {
        data.rows.forEach((rowData, index) => {
            for (const key of Object.keys(rowData)) {
                if (!rowData[key]) {
                    return
                }
                const words = rowData[key].split(" ")
                if (words.length > 10) {
                    rowData[key] = words.slice(0, 10).join(' ') + "..."
                }
            }
        })
        return data
    }

    return (
        <>
            <Sidebar selectedItem={`table/${tableName}`} currentUser={currentUser} />
            <main>
                <Breadcrumb>
                    <Breadcrumb.Item href={`${sitePath}/dashboard`}>Inici</Breadcrumb.Item>
                    <Breadcrumb.Item active>Taules</Breadcrumb.Item>
                    <Breadcrumb.Item active>{tableName}</Breadcrumb.Item>
                </Breadcrumb>
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>{tableName}</h1>
                    </div>
                    <Link to={`/tables/${tableName}/new`}>
                        <Button variant="primary" className="float-end mt-2">
                            Nou element
                        </Button>
                    </Link>
                </header>
                {tableData.rows && tableData.rows.length
                    ? <>
                        <DataTable
                            columns={tableData.columns
                                .filter((column, index) => 
                                    index === 0 || 
                                    (column.comment !== "IMAGE" && column.comment !== "DOCUMENT")
                                )
                                .map(column => ({
                                    Header: column.name,
                                    accessor: column.name,
                                    type: column.comment === "IMAGE"
                                        ? "image"
                                        : column.type,
                                })
                            )}
                            data={tableData.rows}
                            detailURL={`/tables/${tableName}/edit/{id}`}
                            searchPlaceholder="Busca en aquesta taula"
                            filePath={`${filesURL}`}
                        />
                        <small>
                            {tableData.rows.length > 1
                                ? `${tableData.rows.length} registres`
                                : "1 registre"
                            }
                        </small>
                      </>
                    : <small>No hi han registres</small>
                }
                <Link to={`/tables/${tableName}/new`}>
                    <Button variant="primary" className="mt-4">
                        Nou element
                    </Button>
                </Link>
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default TableDetails